module.exports = __webpack_public_path__ + "static/media/ev-page-screenshot.13de4559.png";